import styled from 'styled-components';
import { Text14Bold } from '../utils/Text/Text.styles';

export const UploadFileInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const ButtonContainer = styled.div`
  height: 15rem;
  min-width: 15rem;
  max-width: 15rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.2rem;
  border-radius: 4.933px;
  border: 1.233px dashed #97c9f1;
  background: #fff;
  position: relative;
`;

export const UploadText = styled(Text14Bold)`
  color: #1672ba;
  letter-spacing: -0.408px;
  margin-inline: 2rem;
  text-align: center;
`;
